import React, { useState } from "react";
import { X, Search } from "lucide-react";
import { useNavigate } from "react-router-dom";
import { sortedRegions, getRegionUrlParam } from "../utils/StaticFormData";
import "../styles/StatePickerModal.css";

interface RegionPickerModalProps {
  isOpen: boolean;
  onClose: () => void;
}

export const RegionPickerModal = ({
  isOpen,
  onClose,
}: RegionPickerModalProps) => {
  const [searchTerm, setSearchTerm] = useState("");
  const navigate = useNavigate();

  if (!isOpen) return null;

  const filteredRegions = sortedRegions.filter((item) =>
    item.regionName.toLowerCase().includes(searchTerm.toLowerCase()),
  );

  const handleSelectRegion = (regionName: string) => {
    const alias = getRegionUrlParam(regionName);
    navigate(`/region/${alias}`);
    onClose();
  };

  return (
    <div className="state-modal-overlay" onClick={onClose}>
      <div className="state-modal-content" onClick={(e) => e.stopPropagation()}>
        <div className="state-modal-header">
          <h3>Select a Region</h3>
          <button className="state-modal-close" onClick={onClose}>
            <X size={20} />
          </button>
        </div>

        <div className="state-modal-search">
          <Search size={16} className="search-icon" />
          <input
            type="text"
            placeholder="Search regions..."
            value={searchTerm}
            onChange={(e) => setSearchTerm(e.target.value)}
            autoFocus
          />
        </div>

        <div className="state-modal-grid">
          {filteredRegions.map((item) => (
            <button
              key={item.regionID}
              className="state-item-btn"
              onClick={() => handleSelectRegion(item.regionName)}
            >
              {item.regionName}
            </button>
          ))}
          {filteredRegions.length === 0 && (
            <div className="no-results">No regions found.</div>
          )}
        </div>
      </div>
    </div>
  );
};